import { getAndCacheWithLocalStorage } from "../utils/fhir-cache-patch";
import * as fhirClientLib from "fhirclient/lib/lib";
import React, { useEffect, useState } from "react";
import { oauth2 as SMART } from "fhirclient";
import { Box, Typography } from "@analyticsMD/quil";
import { Loading } from "@analyticsMD/quil";
import { Sizes } from "../types/loadingSizes";
import { FHIR_CONFIG } from "../fhir-config";

// Apply the monkey-patch
// We cast the imported module to `any` to allow us to overwrite its
// exported `getAndCache` function.
(fhirClientLib as any).getAndCache = getAndCacheWithLocalStorage;

const LaunchPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const initializeLaunch = () => {
      try {
        // Get launch parameters from URL
        const urlParams = new URLSearchParams(window.location.search);
        const iss = urlParams.get("iss");
        const launch = urlParams.get("launch");

        if (!iss) {
          throw new Error('Missing "iss" parameter in launch URL');
        }

        if (!launch) {
          throw new Error('Missing "launch" parameter in launch URL');
        }

        // Initialize SMART launch sequence (this will cause a redirect)
        SMART.authorize({
          clientId: FHIR_CONFIG.clientId,
          scope: FHIR_CONFIG.scope,
          redirectUri: FHIR_CONFIG.redirectUri,
          iss: iss,
          launch: launch,
          completeInTarget: true,
        }).catch((err) => {
          console.error("Launch initialization error:", err);
          setError(
            err instanceof Error ? err.message : "Failed to initialize launch"
          );
        });
      } catch (err) {
        console.error("Launch initialization error:", err);
        setError(
          err instanceof Error ? err.message : "Failed to initialize launch"
        );
      }
    };

    initializeLaunch();
  }, []);

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          padding: 2,
        }}
      >
        <Typography variant="h6" color="error" sx={{ marginBottom: 2 }}>
          Launch Error
        </Typography>
        <Typography color="text.secondary">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Box sx={{ marginTop: "25%", height: "100%" }}>
        <Loading message={"Loading..."} logoSize={Sizes.Medium} />
      </Box>
    </Box>
  );
};

export default LaunchPage;
